<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Rory Joe Heynemann is an infant of the 1980s, child of the 1990s and an adult of the 21<sup>st</sup> century who should have been born in the 1950s. He was born and raised in Western Australia, where he attended Curtin University studying Creative Writing. In his mid-20s, he moved to the Gold Coast, Queensland, where he resides to this day. At least upon the writing of this bio.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?2e20f5c1